// MoreFurniture.js

import { Link } from "react-router-dom";
import Breadcrumb from "../../01-atoms/breadcrumbs/Breadcrumbs";

const MoreFurniture = (props) => {
    const { productIcons, productCategoryArray, handleLoading } = props;

    // filtering products
    const productCategory = productCategoryArray.filter((category) => category.fields.moreFurnitureCategory === true);

    // Mapping products and associating them with their images
    const productAssetArray = productCategory.map((product) => ({
        product,
        images: productIcons.filter((asset) => product.fields.name.toLowerCase() === asset.fields.title.toLowerCase()),
    }));

    return (
        <main className="secondary-page__content">
            <div className="wrapper wrapper-secondary">
                <Breadcrumb />
                
                <div className="content-container">
                    <div className="more-furniture">
                        <div className="more-furniture__heading">
                            <h2>EXPLORE MORE FURNITURE</h2>
                        </div>

                        <div className="more-furniture__icons products-content__icons">
                            <ul>
                                {productAssetArray.map((product) => {
                                    return(
                                        <li key={product.images[0].sys.id}>
                                            <Link to={product.images[0].fields.title.replace(/\s+/g, '-')}>
                                                <div className="loading">
                                                    <div className="loading-bar"></div>
                                                </div>
                                                <img src={product.images[0].fields.file.url} alt={product.images[0].fields.title} onLoad={handleLoading} />
                                                <p className="products-content__icons--name">{product.images[0].fields.title}</p>
                                            </Link>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default MoreFurniture;